import { Component, OnInit } from '@angular/core';
import {Events} from "../../constants/events"
import { MapControlService } from '../../services/map-control.service';
import { EnvironmentService } from '../../services/img-source.service';
import { CommonService } from '../../services/common.service';
import { FormControl } from '@angular/forms';
import { tap } from 'rxjs';
@Component({
  selector: 'app-event-tab',
  templateUrl: './event-tab.component.html',
  styleUrls: ['./event-tab.component.scss']
})
export class EventTabComponent implements OnInit {
  replayImgSrc: string;
  events: Object[];
  noDeviceFound:boolean;
  direction :string;
  selectAllFormControl = new FormControl(false)
  constructor(
    private mapControlService: MapControlService,
    private envService: EnvironmentService,
    private commonService: CommonService,
  ) { 
    this.events = Events;
  }

  handleSelectAll(){
    this.selectAllFormControl.valueChanges.subscribe((res)=>  this.mapControlService.setAll(res))
  }
  ngOnInit(): void {
   this.handleSelectAll();
   this.direction = this.commonService.response.tripDetails.direction;
   if(this.commonService.response.tripDetails.routeSource !== 'AUTO'){
    this.events = this.events.filter((event:any)=>{
       return event.event_icon_add !== 'signout-employee'
    })
  }

    this.noDeviceFound = this.commonService.noDeviceFound
    this.replayImgSrc = this.envService.getReplayImgSrc();
  }

  handleCheckbox(eventName: string){
    this.mapControlService.changeFilter(eventName);
  }

}
